import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const getAppSectionStyles = (theme: Theme, type?: string) => ({
	root: {
		display: 'flex',
		backgroundColor: Colors['FF6000'],
		p: { xs: '60px', md: '180px 120px', xl: '180px' },
		mt: { xs: '40px', md: '120px', lg: '160px' },
		position: 'relative',
		flexDirection: { xs: 'column', lg: 'row' },
		alignItems: { xs: 'center', lg: 'unset' },
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: { xs: 'center', lg: 'flex-start' },
		gap: {xs: '16px', sm: '20px', md: '40px' },
		color: '#000',
		flex: 1,
	},
	title: {
		fontSize: { xs: '16px', sm: '36px', lg: '52px' },
		fontFamily: 'Integral CF',
		textAlign: { xs: 'center', lg: 'start' },
	},
	subtitle: {
		display: 'flex',
		fontFamily: 'Integral CF',
		fontSize: { xs: '16px', md: '18px', lg: '20px' },
		fontStyle: 'italic',
	},
	phonesImageBox: {
		position: 'relative',
		width: { xs: '100%', lg: '500px' },
		mb: { xs: '-100px', sm: '-150px', md: '-200px', lg: 0 },
	},
	phonesImageWrapper: {
		width: { xs: '100%', lg: '600px' },
		position: { xs: 'static', lg: 'absolute' },
		top: { xs: 0, lg: '-280px' },
		right: { xs: 0, lg: '-100px' },
	},
});
